import { Component } from 'san';
import * as _ from 'lodash';

import {
    IChildrenProjectsParams,
    IProject,
    IProjectsParams
} from 'src/models';
import { EProjectItemType } from 'src/enums';

import { dateFormat } from 'src/filters';
import Light from 'src/components/Light/Light';
import projectService from 'src/services/project.service';
import auditService from 'src/services/audit.service';

const LEVEL_OFFSET = 24;    // 计划标题每层级的缩进量（px）

export default class IssuedProjectsList extends Component {
    static components = {
        'ui-light': Light
    }

    static filters = {
        dateFormat
    }

    static computed = {
        isCheckedAll() {
            const projects = this.data.get('projects');
            const checkedProjects = _.filter(projects, { _is_checked: true });
            return checkedProjects.length > 0 && checkedProjects.length === projects.length;
        }
    }

    constructor(options: any) {
        super(options);
    }


    initData(): {
        params: IProjectsParams; // {{}}
        projects: IProject[];   // {==}
        projectItemTypeEnum: any;
    } {
        return {
            params: {},
            projects: [],
            projectItemTypeEnum: EProjectItemType
        };
    }

    inited() {
    }

    // 计算标题缩进量
    getTitleLeftOffset(project: IProject): string {
        return project.id_level
            ? 'width:' + (project.id_level - 1) * LEVEL_OFFSET + 'px'
            : ''
    }

    //  收展子项目列表
    scalingSubProjects(project: IProject) {
        if (project._is_busy) {
            return;
        }
        project._is_busy = true;
        const projects: IProject[] = this.data.get('projects');
        const indexOfProject = _.findIndex(projects, {
            id: project.id
        });
        if (project._is_expand) {
            const subList = _.filter(projects, item => {
                return item._sn.startsWith(project._sn + '.');
            });
            this.data.splice('projects', [indexOfProject + 1, subList.length]); // 删除子项目
            project._is_expand = false;
            project._is_busy = false;
            this.data.splice('projects', [indexOfProject, 1, project]);
        } else {
            const params: IChildrenProjectsParams = _.cloneDeep(this.data.get('params'));
            params.puid = project.puid;
            params.item_type = project.item_type;
            projectService.getSentChildrenProjects(project.id, params).then(children => {
                project._is_expand = true;
                project._is_busy = false;
                this.data.splice('projects', [indexOfProject, 1, project]);
                _.forEach(children, (item, index) => {
                    item._sn = project._sn + '.' + (index + 1);
                });
                this.data.splice('projects', [indexOfProject + 1, 0, ...children]);
            });
        }
    }

    goToChange(project: IProject) {
        auditService.toProjectChangeNew([project.puid]);
    }

    goToDetail(project: IProject) {
        const href = EProjectItemType.Schedule === project.item_type
            ? `/audits/schedule/${project.puid}?from=work-center`
            : `/works/project-detail/${project.puid}`;
        window.location.href = `${href}`;
    }

    toggleCheckProject(project: IProject) {
        const projects: IProject[] = this.data.get('projects');
        // const index: number = _.findIndex(projects, { puid: project.puid });
        // const dataKey = `projects[${index}]._is_checked`;
        // this.data.set(dataKey, !project._is_checked);
        _.forEach(projects, p => {
            p._is_checked = p.puid === project.puid && p.id === project.id; // 因“过程调度分组”的puid和其父项目一样，所以通过puid和id这2个属性来确定项目
        });
        this.data.splice('projects', [0, projects.length, ...projects]);
    }

    toggleCheckAll() {
        const isCheckedAll = !this.data.get('isCheckedAll');
        const projects: IProject[] = this.data.get('projects');
        _.forEach(projects, user => {
            user._is_checked = isCheckedAll;
        });
        this.data.splice('projects', [0, projects.length, ...projects]);
    }


}